import React from 'react';
import { Modal, Dots } from '@shared/cove-ui';

const AffirmVerificationModal: React.FC<{
  open: boolean;
  message: string;
}> = ({ open, message = 'Confirming your order through Affirm' }) => {
  return (
    <Modal open={open}>
      <Modal.Content className="w-[calc(100%-30px)] max-w-screen-sm border-0 bg-transparent p-0">
        <div className="flex flex-col items-center gap-cove-15 border-2 border-black bg-white px-cove-25 py-cove-50 sm:px-cove-50">
          <Dots className="bg-cove-blue" />
          <h4 className="text-center text-h4">{message}</h4>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default AffirmVerificationModal;
